import { v4 as uuid } from "uuid";
import { SessionId } from "../types";

export function createSessionId(userId: string): SessionId {
  return `${userId}_${uuid().slice(0, 5)}`;
}

export function extractUserId(sessionId: SessionId) {
  const tokens = sessionId.split("_");
  return tokens.length === 2 ? tokens[0] : null;
}
